import { render, staticRenderFns } from "./AsyncSidebar.vue?vue&type=template&id=24d76599&scoped=true&"
import script from "./AsyncSidebar.vue?vue&type=script&lang=js&"
export * from "./AsyncSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AsyncSidebar.vue?vue&type=style&index=0&id=24d76599&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d76599",
  null
  
)

export default component.exports